export enum GegEvaluatedSystemView {
    Alternative = 'ALTERNATIVE',
    Evaluated = 'EVALUATED_SYSTEM',
    Review = 'REVIEW'
}
